import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef, useCallback } from 'react';
import { ComponoLogoMark } from '../../Logos/ComponoLogoMark.js';
import 'react/jsx-runtime';
import '../../Box/index.js';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { useLayoutScreenContext } from '../../LayoutScreen/LayoutScreen/LayoutScreenContext.js';
import '../../LayoutScreen/LayoutHeader/LayoutHeader.js';
import { MainNavItems } from '../MainNavItems/index.js';
import { MainNavProvider } from '../MainNavContext/index.js';
import { MainNavContainer } from '../MainNavContainer/index.js';
import { MainNavHeader } from '../MainNavHeader/MainNavHeader.js';
import { MainNavSkipLink } from '../MainNavSkipLink/index.js';
import { MainNavToggle } from '../MainNavToggle.js';

var fallbackContext = {
    sidebar: { collapseState: { setOverride: function () { return undefined; } } },
};
var MainNav = forwardRef(function (_a, ref) {
    var children = _a.children, logoMark = _a.logoMark, _b = _a.themeKey, themeKey = _b === void 0 ? "globalNav" : _b, navLinkComponent = _a.navLinkComponent, props = __rest(_a, ["children", "logoMark", "themeKey", "navLinkComponent"]);
    var sidebar = useLayoutScreenContext({ fallbackContext: fallbackContext }).sidebar;
    var _c = sidebar.collapseState, override = _c.override, setOverride = _c.setOverride, isCollapsed = _c.isCollapsed;
    var onMouseEnter = useCallback(function () { return isCollapsed && setOverride(false); }, [isCollapsed]);
    var onMouseLeave = useCallback(function () { return override === false && setOverride(null); }, [override]);
    return (jsx(MainNavProvider, __assign({ themeKey: themeKey, navLinkComponent: navLinkComponent }, { children: jsxs(MainNavContainer, __assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: ref }, props, { children: [jsxs(MainNavHeader, { children: [jsx(MainNavSkipLink, {}), logoMark || jsx(ComponoLogoMark, {}), jsx(MainNavToggle, {})] }), jsx(MainNavItems, { children: children })] })) })));
});
MainNav.displayName = "MainNav";

export { MainNav };
//# sourceMappingURL=index.js.map
